/** @jsx jsx */
import { jsx } from 'theme-ui'
import DashboardTemplate from '../common/sectionTemplate/DashboardTemplate'
import FeatureList from './features/FeatureList'
import HelloTitle from './features/HelloTitle'
import { graphql, useStaticQuery } from 'gatsby'

const Dashboard = () => {
  const { contentfulPageLayout } = useStaticQuery(GET_FEATURES_DATA)
  const contentfulFeatureCardSection = contentfulPageLayout?.contentModules?.filter(
    e => Object.keys(e).length !== 0
  )[0]
  return (
    <DashboardTemplate>
      <HelloTitle
        headline={contentfulFeatureCardSection?.headingSection?.headline}
        subtitle={contentfulFeatureCardSection?.headingSection?.subtitle}
      />
      <FeatureList
        featureCards={contentfulFeatureCardSection?.cardCollection?.card}
      />
    </DashboardTemplate>
  )
}

export const GET_FEATURES_DATA = graphql`
  query FeatureSection {
    contentfulPageLayout(title: { eq: "Homepage" }) {
      contentModules {
        ... on ContentfulFeatureCardSection {
          headingSection {
            title
            headline
            subtitle
          }
          cardCollection {
            title
            card {
              id
              headline
              description
              descriptionRichText {
                raw
              }
              isSocialMediaButton
              slug {
                title
                slug
              }
              cardIcon {
                file {
                  url
                }
              }
              mainSectionButtonLink
              mainSectionButtonText
              subSectionButtonLink
              subSectionButtonText
              subSectionHeadline
              isRichTextCard
            }
          }
        }
      }
    }
  }
`
export default Dashboard
